/** English proper names that stay in English inside translated copy. */
const ENGLISH_BRANDS = /(Golf Digest|Iowa PGA)/u;

export type BrandSegment = { text: string; brand: boolean };

/**
 * Split copy into plain text and English brand names so the brand can carry `lang="en"`.
 * Under CSS `uppercase`, a `lang="tr"` ancestor turns "Digest" into «DİGEST» (dotted İ);
 * `lang="en"` on the brand keeps it «DIGEST».
 */
export function splitEnglishBrands(text: string): BrandSegment[] {
  return text
    .split(ENGLISH_BRANDS)
    .filter((part) => part !== "")
    .map((part) => ({ text: part, brand: ENGLISH_BRANDS.test(part) }));
}
